import api from '../lib/axios'

export function saveModuleState(workspaceId, module, submodule, state) {
    api.put('/module-state', {
        workspace_id: workspaceId ?? 0,
        module,
        submodule: submodule ?? '',
        state,
    }).catch(() => {
        // fire and forget — state writes are best-effort
    })
}
